import { responseHero } from "../utils/axiosInterceptor";
import { MachineDataGroup } from "../types/mining/MachineExpire";

export const getMiningMachineExpires = (): Promise<MachineDataGroup[]> => {
    return new Promise<MachineDataGroup[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/expirations`).then((response) => {
            resolve(response.data as MachineDataGroup[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};